import { Image } from 'component/Image'
import { Space } from 'component/Space'
import { useEffectOnce } from 'hook/useEffectOnce'
import { observer } from 'mobx-react-lite'
import { Dots } from 'page/catalog/ItemPreview/Dots'
import { itemPreview } from 'page/catalog/store/ItemPreviewStore'
import { useEffect, useRef } from 'react'
import { getShortcut } from 'util/keyboard'
import css from './ImagesPane.module.scss'

export const ImagesPane = observer(() => {
  const store = itemPreview.it
  const { current, len, images } = store
  const dots = len > 1
  const ref = useRef<HTMLDivElement>(null)

  useEffectOnce(() => {
    const listener = (event: KeyboardEvent) => {
      const shortcut = getShortcut(event)
      if (shortcut === 'ArrowLeft') --store.current
      if (shortcut === 'ArrowRight') ++store.current
    }

    window.addEventListener('keydown', listener)
    return () => window.removeEventListener('keydown', listener)
  })

  useEffect(() => {
    const image = ref.current?.querySelectorAll('.' + css.image).item(current)
    if (image) image.scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' })
  }, [current])

  return <Space ref={ref} className={css.pane}>
    <Space className={css.line} gap={2}>
      {images.map((image, index) => <Space key={index} className={css.image}>
        <Image src={image} />
      </Space>)}
    </Space>
    {dots && <Space pin={[null, null, 16, 16]}>
      <Dots />
    </Space>}
  </Space>
})
